// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMatchBetFiltersContext from '../../hooks/useMatchBetFiltersContext';
import useMatchViewContext from '../../hooks/useMatchViewContext';
import useMergeProps from '../../hooks/useMergeProps';
import { BetCategories } from '../../types/bet';
import { getBetCategoryIdFromFilterId } from '../../types/matchBetFilters';

import MatchBetHotFilter from './MatchBetHotFilter';
import makeMatchBetHotFilterPropsSelector from './MatchBetHotFilter.selector';

type MatchBetHotFilterContainerProps = {
  className?: string;
};

const MatchBetHotFilterContainer = (ownProps: MatchBetHotFilterContainerProps) => {
  const { matchId } = useMatchViewContext();
  const { filterId, isHotFilterSelected, onHotFilterClicked } = useMatchBetFiltersContext();

  const betCategoryIdFromFilter = getBetCategoryIdFromFilterId(filterId);

  const selector = useMemo(() => makeMatchBetHotFilterPropsSelector(), []);
  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const { nbHotBets } = selectedProps;

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  if (
    [
      BetCategories.SCORERS_SOCCER,
      BetCategories.SCORERS_BASKETBALL,
      BetCategories.SCORERS_RUGBY,
      BetCategories.PLAYER_PROPS,
    ].indexOf(betCategoryIdFromFilter) === -1 &&
    nbHotBets
  ) {
    return <MatchBetHotFilter {...enhancedProps} isSelected={isHotFilterSelected} onClick={onHotFilterClicked} />;
  }

  return null;
};

export default MatchBetHotFilterContainer;
